import script from "./BlogClientView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogClientView.vue?vue&type=script&setup=true&lang=js"

import "./BlogClientView.vue?vue&type=style&index=0&id=15362dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15362dd6"]])

export default __exports__